<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  totalDates: {
    type: Number,
    required: true,
  },
  daysDiff: {
    type: Number,
    required: true,
  },
  frequency: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <!-- Total de Envios -->
    <div
      class="group bg-gradient-to-br from-white to-n-slate-1 dark:from-n-slate-12 dark:to-n-slate-11 rounded-xl p-6 border border-n-slate-4 dark:border-n-slate-8 hover:shadow-lg hover:border-n-blue-6 dark:hover:border-n-blue-8 transition-all duration-300"
    >
      <div class="flex items-center justify-between mb-3">
        <div
          class="w-10 h-10 bg-gradient-to-br from-n-blue-9 to-n-blue-11 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            />
          </svg>
        </div>
        <div class="text-right">
          <div
            class="text-3xl font-bold text-n-blue-11 dark:text-n-blue-3 leading-none"
          >
            {{ totalDates }}
          </div>
          <div
            class="text-xs text-n-blue-9 dark:text-n-blue-6 font-medium mt-1"
          >
            {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.SENDS') }}
          </div>
        </div>
      </div>
      <div class="text-sm text-n-slate-11 dark:text-n-slate-4">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.SENDS_LABEL') }}
      </div>
    </div>

    <!-- Duração da Campanha -->
    <div
      class="group bg-gradient-to-br from-white to-n-slate-1 dark:from-n-slate-12 dark:to-n-slate-11 rounded-xl p-6 border border-n-slate-4 dark:border-n-slate-8 hover:shadow-lg hover:border-n-iris-6 dark:hover:border-n-iris-8 transition-all duration-300"
    >
      <div class="flex items-center justify-between mb-3">
        <div
          class="w-10 h-10 bg-gradient-to-br from-n-iris-9 to-n-iris-11 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <div class="text-right">
          <div
            class="text-3xl font-bold text-n-iris-11 dark:text-n-iris-3 leading-none"
          >
            {{ daysDiff }}
          </div>
          <div
            class="text-xs text-n-iris-9 dark:text-n-iris-6 font-medium mt-1"
          >
            {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.DAYS') }}
          </div>
        </div>
      </div>
      <div class="text-sm text-n-slate-11 dark:text-n-slate-4">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.DAYS_LABEL') }}
      </div>
    </div>

    <!-- Frequência -->
    <div
      class="group bg-gradient-to-br from-white to-n-slate-1 dark:from-n-slate-12 dark:to-n-slate-11 rounded-xl p-6 border border-n-slate-4 dark:border-n-slate-8 hover:shadow-lg hover:border-n-teal-6 dark:hover:border-n-teal-8 transition-all duration-300"
    >
      <div class="flex items-center justify-between mb-3">
        <div
          class="w-10 h-10 bg-gradient-to-br from-n-teal-9 to-n-teal-11 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>
        <div class="text-right flex-1 min-w-0">
          <div
            class="text-lg font-bold text-n-teal-11 dark:text-n-teal-3 leading-tight truncate"
          >
            {{ frequency }}
          </div>
          <div
            class="text-xs text-n-teal-9 dark:text-n-teal-6 font-medium mt-1"
          >
            {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.FREQUENCY') }}
          </div>
        </div>
      </div>
      <div class="text-sm text-n-slate-11 dark:text-n-slate-4">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.STATS.FREQUENCY_LABEL') }}
      </div>
    </div>
  </div>
</template>
